import React, { FunctionComponent, memo } from "react";
import { TopBar } from "@web-components-proxy";
import HeaderNavigationBar from "../HeaderNavigationBar/HeaderNavigationBar";
import ProfileMenu from "./components/ProfileMenu/ProfileMenu";
import { Link } from "react-router-dom";
import CloudDeskLogo from "@assets/images/platform-white.svg";

import { useSelector } from "react-redux";
import { useGeneralErrorHandler } from "@http";
import useHeartbeat from "./useHeartbeat";
import useSessionsList from "./useSessionsList";
import useCheckUnsavedNotes from "./useCheckUnsavedNotes";
import {
  isEmployeeDashboardPermission,
  selectIsAuthenticated,
} from "@store/userData/selectors";

import "./Header.scss";

const Header: FunctionComponent = () => {
  const authenticated = useSelector(selectIsAuthenticated);
  const setError = useGeneralErrorHandler();
  const isAdmin = useSelector(isEmployeeDashboardPermission);

  const homePath = "/home";
  const sessionsPath = "/sessions/verify-pin";
  const loginPath = "/login";

  const redirectPath = authenticated
    ? isAdmin
      ? homePath
      : sessionsPath
    : loginPath;

  useHeartbeat(setError);
  useSessionsList();
  useCheckUnsavedNotes();

  return (
    <header className="header">
      <TopBar is-sticky="false" class="header__main">
        <div className="header__logoContainer">
          <Link to={redirectPath}>
            <div className="header__logo">
              <img src={CloudDeskLogo} alt="Caspio Clouddesk"></img>
            </div>
          </Link>
        </div>
        <div className="header__actions">
          {authenticated && (
            <>
              <HeaderNavigationBar />
              <div className="header__divider"></div>
              <ProfileMenu />
            </>
          )}
        </div>
      </TopBar>
    </header>
  );
};
export default memo(Header);
